import React from "react";
import InvoiceRow from "./InvoiceRow";

const COLS = [
  "Vendor & ID", "Category", "Sub-category", "Phase", "Block",
  "Issue Date", "Due Date", "Amount", "Status", "Action",
];

const InvoiceTable = ({ invoices, loading, onEdit, onDelete, showVendorLink = true }) => (
  <div className="bg-white rounded-top-3 overflow-hidden shadow-sm border-start border-end border-top">
    <div className="table-responsive">
      <table className="table table-hover align-middle mb-0">
        <thead>
          <tr style={{ background: "rgb(240,240,240)" }}>
            {COLS.map((col, i) => (
              <th key={col}
                className={`px-4 py-3 fw-bold border-0${i === 7 ? " text-end" : i === 9 ? " text-center" : ""}`}
                style={{ fontSize: "0.6rem", textTransform: "uppercase", letterSpacing: "0.08em", color: "#74777f" }}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="border-top">
          {loading && (
            <tr>
              <td colSpan={COLS.length} className="text-center py-5">
                <div className="spinner-border spinner-border-sm text-primary" role="status">
                  <span className="visually-hidden">Loading…</span>
                </div>
              </td>
            </tr>
          )}
          {!loading && invoices.length === 0 && (
            <tr>
              <td colSpan={COLS.length} className="text-center py-5 text-muted">
                <i className="ri-file-list-3-line display-5 d-block mb-2" />
                No vendor invoices found. Import your first batch to get started.
              </td>
            </tr>
          )}
          {!loading && invoices.map((invoice) => (
            <InvoiceRow key={invoice.id} invoice={invoice} onEdit={onEdit} onDelete={onDelete} showVendorLink={showVendorLink} />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default InvoiceTable;
